import Register from "views/examples/Register.js";
import Login from "views/examples/Login.js";

import Solicitudes from "views/examples/Solicitudes";

import Cookies from "universal-cookie";

import SolicitudesPropias from "views/examples/SolicitudesPropias";
import ConsultarGlpi from "views/GLPI/ConsultarGlpi";
import ConsultaAbastecimiento from "views/examples/ConusltaAbastecimiento";
import Repositorio from "views/examples/Repostitorio";

const cookie = new Cookies();
var routesAprobador = [
  {
    path: "/Solicitudes/" + cookie.get("correo"),
    name: "Solicitudes",
    icon: "ni ni-bullet-list-67 text-blue",
    component: <SolicitudesPropias />,
    layout: "/admin",
  },
  {
    path: "/SolicitudesAsignadas/" + cookie.get("correo"),
    name: "Solicitudes Asignadas",
    icon: "ni ni-bullet-list-67 text-blue",
    component: <Solicitudes />,
    layout: "/admin",
  },
  {
    path: "/Consultas",
    name: "Consultar Casos Abastecimiento",
    icon: "ni ni-bullet-list-67 text-blue",
    component: <ConsultaAbastecimiento />,
    layout: "/admin",
  },
  {
    path: "/ConsultaGLPI",
    name: "Documentos GLPI",
    icon: "ni ni-bullet-list-67 text-blue",
    component: <ConsultarGlpi />,
    layout: "/admin",
  },
  {
    path: "/Repositorio",
    name: "Repositorio  ",
    icon: "ni ni-bullet-list-67 text-blue",
    component: <Repositorio />,
    layout: "/admin",
  },
  {
    path: "/login",

    component: <Login />,
    layout: "/auth",
  },
  {
    path: "/register",

    component: <Register />,
    layout: "/auth",
  },
];
export default routesAprobador;
